import React from "react";

import { DataTable } from "../../types/data/DataTable";

import rowIndicator from "./RowIndicator.png";

interface ImportGridBodyProps {
    data: DataTable;
}

interface ImportGridBodyState {}

class ImportGridBody extends React.Component<
    ImportGridBodyProps,
    ImportGridBodyState
> {
    render(): React.ReactNode {
        return (
            <tbody>
                {this.props.data.map((record, index) => (
                    <tr key={index}>
                        <td className="icon">
                            <img
                                src={rowIndicator}
                                alt="icon"
                            />
                        </td>
                        {Object.keys(record).map((column, colIndex) => (
                            <td key={colIndex}>{record[column]}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        );
    }
}

export default ImportGridBody;
